"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../utils");

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _submitPql = require("ui-addon-upgrades/_core/pql/submitPql");

var _ContactSalesPropsInterface = require("ui-addon-upgrades/_core/contactSales/ContactSalesPropsInterface");

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _CommunicationMethodsPrompt = require("ui-addon-upgrades/_core/communicationMethods/CommunicationMethodsPrompt");

var _salesPhoneNumbers = _interopRequireDefault(require("ui-addon-upgrades/_core/common/constants/salesPhoneNumbers"));

var _UnassignableModal = _interopRequireDefault(require("../communicationMethods/UnassignableModal"));

var BUTTON_STATUSES = (0, _keyMirror.default)({
  INITIAL: null,
  LOADING: null,
  SUCCESS: null
});
var CLICK_DELAY = 50;

function sequence() {
  for (var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++) {
    handlers[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    handlers.forEach(function (handler) {
      return handler && handler.apply(void 0, args);
    });
  };
}

var ContactSalesButton = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ContactSalesButton, _React$Component);

  function ContactSalesButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ContactSalesButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ContactSalesButton).call(this, props));
    _this.state = {
      buttonStatus: BUTTON_STATUSES.INITIAL,
      showUnassignableModal: false
    };
    _this.debouncedHandleClick = (0, _utils.debounce)(_this.handleClick.bind((0, _assertThisInitialized2.default)(_this)), CLICK_DELAY);
    return _this;
  }

  (0, _createClass2.default)(ContactSalesButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          upgradeData = _this$props.upgradeData,
          termId = _this$props.termId,
          additionalUnitQuantity = _this$props.additionalUnitQuantity;
      tracker.track('contactSalesButtonInteraction', Object.assign({
        action: 'viewed'
      }, upgradeData, {
        termId: termId,
        additionalUnitQuantity: additionalUnitQuantity
      }));
    }
  }, {
    key: "handleContactSales",
    value: function handleContactSales() {
      var _this2 = this;

      var _this$props2 = this.props,
          upgradeData = _this$props2.upgradeData,
          allowModal = _this$props2.allowModal,
          termId = _this$props2.termId,
          additionalUnitQuantity = _this$props2.additionalUnitQuantity,
          onCancel = _this$props2.onCancel,
          _overrideCommunicationMethodKey = _this$props2._overrideCommunicationMethodKey,
          _overrideModalHeaderText = _this$props2._overrideModalHeaderText;
      tracker.track('contactSalesButtonInteraction', Object.assign({
        action: 'clicked'
      }, upgradeData, {
        termId: termId,
        additionalUnitQuantity: additionalUnitQuantity
      }));
      var pqlData = Object.assign({}, upgradeData, {
        termId: termId,
        additionalUnitQuantity: additionalUnitQuantity
      });

      if (allowModal) {
        (0, _submitPql.submitPql)(pqlData);
        (0, _CommunicationMethodsPrompt.CommunicationMethodsPrompt)(Object.assign({
          upgradeData: upgradeData,
          onCancel: onCancel
        }, _overrideCommunicationMethodKey && {
          _overrideCommunicationMethodKey: _overrideCommunicationMethodKey
        }, {}, _overrideModalHeaderText && {
          _overrideModalHeaderText: _overrideModalHeaderText
        }));
        return;
      }

      this.setState({
        buttonStatus: BUTTON_STATUSES.LOADING
      });
      (0, _submitPql.submitPql)(pqlData).then(function () {
        _this2.setState({
          buttonStatus: BUTTON_STATUSES.SUCCESS
        });
      });
    }
  }, {
    key: "handleContactIsc",
    value: function handleContactIsc() {
      var _this$props3 = this.props,
          upgradeData = _this$props3.upgradeData,
          termId = _this$props3.termId,
          additionalUnitQuantity = _this$props3.additionalUnitQuantity;
      tracker.track('contactSalesButtonInteraction', Object.assign({
        action: 'clicked talk to ISC'
      }, upgradeData, {
        termId: termId,
        additionalUnitQuantity: additionalUnitQuantity
      }));
      this.setState({
        showUnassignableModal: true
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var repInfo = this.props.upgradeData.repInfo; // If no rep info fetched or if no rep link returned, use unassignable treatment

      if (!repInfo || repInfo && !repInfo.link) {
        return this.handleContactIsc();
      }

      return this.props.contactIsc || window.location.search.includes('assignable=false') ? this.handleContactIsc() : this.handleContactSales();
    }
  }, {
    key: "renderSuccess",
    value: function renderSuccess() {
      return _react.default.createElement("div", null, _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.contactSalesButton.success"
      })), _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.contactSalesButton.callNow"
      })), _react.default.createElement("h4", null, _salesPhoneNumbers.default.DEFAULT));
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      return _react.default.createElement("div", {
        style: {
          width: '150px',
          textAlign: 'center',
          display: 'inline-block'
        }
      }, _react.default.createElement("div", {
        style: {
          display: 'inline-block'
        }
      }, _react.default.createElement(_UILoadingSpinner.default, null)));
    }
  }, {
    key: "renderButton",
    value: function renderButton() {
      var _this$props4 = this.props,
          onClick = _this$props4.onClick,
          forwardedRef = _this$props4.forwardedRef,
          _buttonOverride = _this$props4._buttonOverride;
      var onClickSequence = sequence(this.debouncedHandleClick, onClick);
      var propsToPass = (0, _utils.omit)(this.props, ['forwardedRef', 'onClick', 'upgradeData', 'allowModal', 'contactIsc', 'termId', 'additionalUnitQuantity', '_textOverride', '_overrideCommunicationMethodKey', '_buttonOverride', '_overrideModalHeaderText']);

      var buttonText = this.props._textOverride || _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.contactSalesButton.text"
      }); // For use cases that require a different component than a UIButton


      if (_buttonOverride) {
        return _react.default.createElement("div", {
          onClick: onClickSequence,
          "data-selenium": "contact-sales-button",
          "data-reagan-primary-cta": true
        }, _buttonOverride);
      }

      return _react.default.createElement(_UIButton.default, Object.assign({
        buttonRef: forwardedRef,
        onClick: onClickSequence
      }, propsToPass, {
        "data-selenium": "contact-sales-button",
        "data-reagan-primary-cta": true
      }), buttonText);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          buttonStatus = _this$state.buttonStatus,
          showUnassignableModal = _this$state.showUnassignableModal;
      var _this$props5 = this.props,
          upgradeData = _this$props5.upgradeData,
          onCancel = _this$props5.onCancel;
      var button;

      if (buttonStatus === BUTTON_STATUSES.SUCCESS) {
        button = this.renderSuccess();
      } else if (buttonStatus === BUTTON_STATUSES.LOADING) {
        button = this.renderLoading();
      } else {
        button = this.renderButton();
      }

      return _react.default.createElement(_react.default.Fragment, null, button, showUnassignableModal && _react.default.createElement(_UnassignableModal.default, {
        upgradeData: upgradeData,
        onClose: function onClose() {
          _this3.setState({
            showUnassignableModal: false
          });

          onCancel();
        }
      }));
    }
  }]);
  return ContactSalesButton;
}(_react.default.Component);

ContactSalesButton.defaultProps = {
  use: 'primary',
  onClick: function onClick() {},
  onCancel: function onCancel() {},
  allowModal: true,
  contactIsc: false,
  // For unassigned users to be able to meet with ISCs, rather than sales reps
  _textOverride: null,
  _buttonOverride: null,
  _overrideCommunicationMethodKey: null,
  _overrideModalHeaderText: null
};
ContactSalesButton.propTypes = _ContactSalesPropsInterface.ContactSalesButtonPropsInterface;
var _default = ContactSalesButton;
exports.default = _default;
module.exports = exports.default;